import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {
    filterDropdown_template
} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDropdown_template";
import {PollFormatter} from "../../utils/PollFormatter";
import {PollMarkup} from "./pollMarkup";
import {InsertDropdownController} from "../../utils/InsertDropdownController";

declare var ko: any;

export interface PollPickerInsertData {
    idPoll: string | number;
    pollName: string;
    isWithTitle: boolean;
    isDynamicPlacement: boolean;
}

export class pollPickerView_template extends vnTemplate {
    protected parent: any;
    public brandSingleFilter: filterDropdown_template;
    protected insertDropdown: InsertDropdownController;

    protected getTemplateHtml(): string {
        const metaRows = PollMarkup.viewInfoRow('ID', "id() || 'New'")
            + PollMarkup.viewInfoRow('Number of Questions', 'questions().length');

        return /* html */ `
            <div class="w-picker-form form-edit form-poll" id="poll-picker-view" data-bind="css: { 'is-visible': isShown }">
                <div class="picker-form">
                    <div class="form-header w-justify">
                        <div class="w-left"></div>
                        <div class="w-center">
                            <div class="section-title">
                                <h3 class="section-title icon i-poll">Poll</h3>
                            </div>
                        </div>
                        <div class="w-right">
                            <button type="button" class="close-btn icon i-close" data-bind="event: { click: onClickCancel }"></button>
                        </div>
                    </div>

                    <div class="quiz-picker-scroll">
                        <div class="w-form-body">
                            <div class="form-body full-width quiz-picker-actions">
                                <div class="body-header w-justify">
                                    <div class="w-left">
                                        <button type="button" class="btn icon i-edit" data-bind="event: { click: onClickEdit }">Edit Poll Source</button>
                                    </div>
                                    <div class="w-right">
                                        ${PollMarkup.displayTitleCheckbox('poll-picker-view-with-title')}
                                        ${PollMarkup.insertDropdown({
                                            toggleLabel: 'Insert',
                                            clickHandler: 'onClickInsert',
                                            titlePrefix: 'Insert',
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>

                        ${PollMarkup.sectionHeading('Info')}
                        ${PollMarkup.viewInfoPanel(metaRows)}
                        ${PollMarkup.sectionHeading('Questions')}
                        ${PollMarkup.viewToolbar(this.brandSingleFilter.getHtmlBuild())}
                        ${PollMarkup.emptyQuestions()}
                        ${PollMarkup.questionViewCards()}
                    </div>
                </div>
            </div>
        `;
    }

    protected buildViewModel(): any {
        const self = this;
        return {
            isShown: ko.observable(false),
            poll: ko.observable(null),
            id: ko.observable(null),
            name: ko.observable(""),
            attachedBrands: ko.observable(""),
            referenceArticleTitle: ko.observable(""),
            discussionArticleTitle: ko.observable(""),
            dateClosed: ko.observable(null),
            dateCreated: ko.observable(""),
            questions: ko.observableArray([]),
            brandReferences: ko.observableArray([]),
            isWithTitle: ko.observable(false),
            isDynamicPlacement: ko.observable(false),
            isInsertDropdownOpen: ko.observable(false),
            exportInProgress: ko.observable(false),
            exportTextBox: ko.observable("Export to CSV"),
            onClickExportToCSV: () => self.onClickExportToCSV(),
            onClickCancel: () => self.hide(),
            onClickInsert: (isDynamicPlacement) => self.onClickInsert(isDynamicPlacement),
            onClickToggleInsertDropdown: (data, event) => {
                event.stopPropagation();
                self.insertDropdown.toggle();
            },
            onClickEdit: () => self.onClickEdit(),
        };
    }

    protected initPartial(): void {
        this.brandSingleFilter = new filterDropdown_template("pollPickerViewBrandSingleFilter", this.getTemplateViewModel(), this);
        this.insertDropdown = new InsertDropdownController(this.getTemplateViewModel().isInsertDropdownOpen);
    }

    protected getTemplateName(): string {
        return "pollPickerView-template";
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): Array<string> {
        return [];
    }

    public setParent(parent): this {
        this.parent = parent;
        return this;
    }

    public setPoll(poll): void {
        const fallbackBrandId = this.parent && this.parent.getIdBrand ? this.parent.getIdBrand() : null;
        const formattedPoll = PollFormatter.formatForView(poll, fallbackBrandId);
        this.getTemplateViewModel().poll(poll);
        this.getTemplateViewModel().id(formattedPoll.id);
        this.getTemplateViewModel().name(formattedPoll.name);
        this.getTemplateViewModel().dateClosed(formattedPoll.dateClosed);
        this.getTemplateViewModel().dateCreated(formattedPoll.dateCreated);
        this.getTemplateViewModel().isWithTitle(formattedPoll.isWithTitle);
        this.getTemplateViewModel().questions(formattedPoll.questions);
        this.setReferenceArticle(formattedPoll.referenceArticle);
        this.setDiscussionArticleTitle(formattedPoll.discussionArticleTitle);
        this.setBrandResults(formattedPoll.questions, formattedPoll.brandResults.length > 0 ? formattedPoll.brandResults : (poll.brands || []));
    }

    public getPollData() {
        return this.getTemplateViewModel().poll();
    }

    public getId() {
        return this.getTemplateViewModel().id();
    }

    public getName() {
        return this.getTemplateViewModel().name();
    }

    /**
     * Brand scope for the CSV export; null means the whole network.
     */
    public getSelectionBrandId() {
        const selectedBrand: any = this.brandSingleFilter.getSelectedOption();

        return selectedBrand && selectedBrand.id > 0 ? selectedBrand.id : null;
    }

    public getCurrentBrandName() {
        const selectedBrand: any = this.brandSingleFilter.getSelectedOption();

        return selectedBrand ? selectedBrand.shortName : null;
    }

    public asExportInProgress(exportInProgress): void {
        this.getTemplateViewModel().exportInProgress(exportInProgress);
    }

    public isExportInProgress() {
        return this.getTemplateViewModel().exportInProgress();
    }

    public setExportTextBox(exportTextBox): void {
        this.getTemplateViewModel().exportTextBox(exportTextBox);
    }

    protected onClickExportToCSV(): void {
        if (this.isExportInProgress() || !this.getId()) {
            return;
        }

        this.asExportInProgress(true);
        this.setExportTextBox("Exporting...");
        this.parent.exportPoll();
    }

    public resetExportState(): void {
        this.asExportInProgress(false);
        this.setExportTextBox("Export to CSV");
    }

    public setReferenceArticle(article): void {
        const articleId = article && (article.id || article.idArticle);
        const articleTitle = article ? (article.title || article.name || `Article #${articleId}`) : "";
        this.getTemplateViewModel().referenceArticleTitle(articleTitle);
    }

    /** Discussion article of the article's brand; the other brands' articles are not shown here. */
    public setDiscussionArticleTitle(discussionArticleTitle): void {
        this.getTemplateViewModel().discussionArticleTitle(discussionArticleTitle || "");
    }

    public setReferences(references): void {
        this.setBrandReferences(references.brands || []);
    }

    public setBrandReferences(brandReferences): void {
        this.getTemplateViewModel().brandReferences((brandReferences || []).map((brandReference) => ({
            id: brandReference.id,
            name: brandReference.name,
            shortName: brandReference.shortName,
        })));
    }

    public setBrandResults(networkResults, brandResults): void {
        const formattedPoll = PollFormatter.formatForView({
            questions: networkResults,
            brandResults: brandResults && brandResults.length > 0 && typeof brandResults[0] === "object" ? brandResults : [],
        });
        const references = this.getTemplateViewModel().brandReferences() || [];
        const brandReferences: Array<any> = [{id: -1, name: "Network", questions: formattedPoll.questions || [], shortName: "Network"}];
        const brandNames = [];

        if (brandResults && brandResults.length > 0 && typeof brandResults[0] === "object") {
            for (const reference of references) {
                for (const result of formattedPoll.brandResults) {
                    if (result.isActive && Number(result.idBrand) === Number(reference.id)) {
                        brandReferences.push({id: reference.id, name: reference.name, questions: result.questions, shortName: reference.shortName});
                        brandNames.push(reference.shortName || reference.name);
                    }
                }
            }
        } else {
            const activeBrandIds = (brandResults || []).map((brandId) => Number(brandId));
            for (const reference of references) {
                if (activeBrandIds.indexOf(Number(reference.id)) !== -1) {
                    brandReferences.push({id: reference.id, name: reference.name, questions: formattedPoll.questions || [], shortName: reference.shortName});
                    brandNames.push(reference.shortName || reference.name);
                }
            }
        }

        this.getTemplateViewModel().attachedBrands(brandNames.join(", "));
        this.brandSingleFilter.setOptions(brandReferences);
        this.brandSingleFilter.setSelectedOption(-1);
    }

    public filterDropdownOnChange(idElement): void {
        if (idElement === "pollPickerViewBrandSingleFilter") {
            const selectedBrand: any = this.brandSingleFilter.getSelectedOption();
            if (selectedBrand) {
                this.getTemplateViewModel().questions(selectedBrand.questions || []);
            }
        }
    }

    public setIsWithTitle(isWithTitle): void {
        this.getTemplateViewModel().isWithTitle(!!isWithTitle);
    }

    public setIsDynamicPlacement(isDynamicPlacement): void {
        this.getTemplateViewModel().isDynamicPlacement(!!isDynamicPlacement);
    }

    public getPollForInsert(): PollPickerInsertData | null {
        const poll = this.getPollData();
        if (!poll || !poll.id) {
            return null;
        }

        return {
            idPoll: poll.id,
            pollName: poll.name || "Poll",
            isWithTitle: !!this.getTemplateViewModel().isWithTitle(),
            isDynamicPlacement: !!this.getTemplateViewModel().isDynamicPlacement(),
        };
    }

    public show(): void {
        this.getTemplateViewModel().isShown(true);
    }

    public hide(): void {
        this.insertDropdown.close();
        this.getTemplateViewModel().isShown(false);
    }

    public showLoading(): void {
        const form = document.getElementById("poll-picker-view");
        form && form.classList.add("loading");
    }

    public hideLoading(): void {
        const form = document.getElementById("poll-picker-view");
        form && form.classList.remove("loading");
    }

    protected onClickInsert(isDynamicPlacement): void {
        const pollData = this.getPollForInsert();
        if (!pollData) {
            return;
        }

        pollData.isDynamicPlacement = !!isDynamicPlacement;
        this.insertDropdown.close();
        this.parent.insertPoll(pollData);
    }

    protected onClickEdit(): void {
        const poll = this.getPollData();
        if (!poll) {
            return;
        }

        this.parent.editPoll(poll);
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/pollPickerView_template.ts